module.exports = __webpack_public_path__ + "img/noresults.8c3d2a79.svg";